// import $ from 'jquery';
import moment from "moment";
import "lodash"
import "clndr";

$(function () {
    moment.locale("ja", {
        months: '01_02_03_04_05_06_07_08_09_10_11_12'.split('_'),
        monthsShort: '01_02_03_04_05_06_07_08_09_10_11_12'.split('_'),
    })

    const clndrTemplate = `<div class="clndr-controls">
                    <button class="clndr-previous-button" type="button" aria-label="前の月へ"><span class="material-symbols-outlined" aria-hidden="true">
                        arrow_back_ios
                      </span></button>
                    <div class="month clndr-select-month-button" id="calendar-title">
                      <span class="year-num"><%= year %>年</span>
                      <span class="month-num"><%= month %>月</span>
                    </div>
                    <button class="clndr-next-button" type="button" aria-label="次の月へ"> <span class="material-symbols-outlined" aria-hidden="true">
                        arrow_forward_ios
                      </span></button>
                  </div>
                  <table class="calendar-table">
                    <thead>
                      <tr class="header-days">
                        <% for(var i = 0; i < daysOfTheWeek.length; i++) 
                            { %><th scope="col" class='header-day <%= daysOfTheWeek[i].key %>'><%= daysOfTheWeek[i].label %></th ><% } 
                        %> 
                      </tr>
                    </thead>
                    <tbody>
                    <% for(var i = 0; i < numberOfRows; i++){ %> 
                            <tr> 
                                <% for(var j = 0; j < 7; j++){ %> 
                                    <% var d = j + i * 7; %>  
                                    <td class='<%= days[d].classes %>'> 
                                        <div class='day-contents <%= days[d].events.length ? "has-event" : "" %>' 
                                            <%= days[d].events.length ? 'role="button" tabindex="0" aria-haspopup="dialog"' : '' %>>
                                            <%= days[d].day %>
                                        </div>
                                    </td>
                                <%}%>
                            </tr>
                        <% } %> 
                    </tbody>
                  </table>`;

    // Get Data By Day
    const getDataByDay = (data, el) => {
        const day = data.format("YYYYMMDD")
        $.ajax({
            // url: jomon_event_config.api,
            url: jomon_event_post_config.api,

            type: 'post',
            data: {
                // nonce: jomon_event_config.nonce,
                nonce: jomon_event_post_config.nonce,
                // action: jomon_event_config.day_action,
                action: jomon_event_post_config.day_action,

                query: day
            },
            success: function (response) {
                if (response.status) {
                    el && openModal(el, Object.entries(response.areas));
                }
            }
        });
    }

    // Get Data By Month
    const getDataByMonth = (data) => {
        const dataByMonth = data.format("YYYYMM");
        $.ajax({
            // url: jomon_event_config.api,
            url: jomon_event_post_config.api,

            type: 'post',
            data: {
                // nonce: jomon_event_config.nonce,
                nonce: jomon_event_post_config.nonce,

                // action: jomon_event_config.month_action,
                action: jomon_event_post_config.month_action,

                query: dataByMonth
            },
            success: function (response) {
                if (response.status) {
                    let eventsMonth = response.events;
                    let eventDay;
                    for (var key in eventsMonth) {
                        if (eventsMonth[key]) {
                            eventDay = data.format("YYYY-MM-") + key;
                            calendar.addEvents([
                                {
                                    date: moment(eventDay, "YYYY-MM-DD")
                                }
                            ]);
                        }
                    }
                }
            }
        });
    }

    let calendar = $('#template-calendar').clndr({
        template: clndrTemplate,
        daysOfTheWeek: [
            { key: 'sun', label: '日' },
            { key: 'mon', label: '月' },
            { key: 'tue', label: '火' },
            { key: 'wed', label: '水' },
            { key: 'thu', label: '木' },
            { key: 'fri', label: '金' },
            { key: 'sat', label: '土' },
        ],

        ready: function () {
            $.when(
                getDataByDay(moment()),
                getDataByMonth(moment()),
            ).then(function () {
                console.log("completed")
            })
        },
        clickEvents: {
            click: function (target) {
                const el = target.element.querySelector('.day-contents');

                if (!el || !el.classList.contains('has-event')) {
                    return;
                }

                getDataByDay(target.date, target.element);
            },
            onMonthChange: function (month) {
                getDataByMonth(month)
            },
        },
        weekOffset: 1,
        formatWeekdayHeader: function (day) {
            return day.format('ddd');
        }
    });
});

/**
 * 日付文字列 'YYYY-MM-DD' を 'YYYY年M月D日のイベント' に変換する
 */
function formatDate(dateStr) {
    const [y, m, d] = dateStr.split('-');
    return `${y}年${parseInt(m)}月${parseInt(d)}日のイベント`;
}

/**
 * モーダル内のイベントリストを更新する
 */
function renderEvents(events) {
    const list = document.querySelector('.event-modal-list');
    if (!list) return;

    list.innerHTML = events
        .flatMap(([area, ev]) =>
            ev.events.map(item => ({
                ...item,
                label: ev.label
            }))
        )
        .map(item => `
    <li class="event-modal-item">
      <a href="${item.url}" class="event-modal-link">
        <div class="event-name">
          <span class="event-modal-name">${item.title}</span>
          <span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
        </div>
        <div class="event-info">
          <span class="date">
            開催期間：
            <time datetime="${item.start}">${item.start}</time> 〜 
            <time datetime="${item.end}">${item.end}</time>
          </span>
          ${item.label ? `<span class="tags">#${item.label}</span>` : ``}
        </div>
      </a>
    </li>
  `)
        .join('');
}

/**
 * モーダルを開く
 */
function openModal(trigger, events) {
    const modalEl = document.getElementById('eventModal');
    const modalTitle = document.getElementById('eventModalLabel');
    if (!modalEl || !modalTitle) return;

    // 親の <td> に付いている calendar-day-YYYY-MM-DD クラスから日付を取得
    const td = trigger.closest('td');
    const dateClass = td
        ? [...td.classList].find((c) => c.startsWith('calendar-day-'))
        : null;
    const dateStr = dateClass ? dateClass.replace('calendar-day-', '') : '';

    modalTitle.textContent = dateStr ? formatDate(dateStr) : 'イベント情報';
    renderEvents(events);

    // bootstrap はグローバル変数として読み込まれている
    const bsModal = bootstrap.Modal.getOrCreateInstance(modalEl);
    bsModal.show();
}

document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    const el = document.activeElement;
    if (!el || !el.classList.contains('has-event')) return;

    e.preventDefault();
    el.click();
});
